import HTML from './HTML';

export default HTML;
